import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgApexchartsModule } from 'ng-apexcharts';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { materialForm, materialTable, sharedMaterials } from 'src/app/shared/material';
import { NgxMatPaginatorComponent } from './components/ngx-mat-paginator/ngx-mat-paginator.component';
import { components, entryComponents } from './components';
import { directives } from './directive';
import { pipes } from './pipes';

@NgModule({
  declarations: [
    components,
    pipes,
    directives,
    NgxMatPaginatorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgApexchartsModule,
    sharedMaterials,
    materialForm,
    materialTable
  ],
  entryComponents: [entryComponents],
  exports: [components, pipes, directives, NgxMatPaginatorComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedModule { }
